"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagSchema = exports.FlagValue = void 0;
const codegen_1 = require("@azure-tools/codegen");
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class FlagValue extends codegen_1.Initializer {
    constructor(name, description, value, objectInitializer) {
        super();
        this.value = value;
        this.language.default = {
            name,
            description,
        };
        this.apply(objectInitializer);
    }
}
exports.FlagValue = FlagValue;
class FlagSchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Flag);
        this.apply(objectInitializer);
    }
}
exports.FlagSchema = FlagSchema;
//# sourceMappingURL=flag.js.map